import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RestCountriesService {

  constructor(private httpClient: HttpClient) { }

  getPhonesList(): Observable<any> {
    return this.httpClient.get<any>(`https://restcountries.com/v3.1/all/?fields=name,idd,flags,translations`);
  }
}
